<template>
    <div class="ad-box">
        <div class="ad-title">
            <img src="../../assets/storage/ad-text.png" class="ad-text">
            <div class="text">有包裹的地方就有我</div>
        </div>
        <div>
            <img src="../../assets/storage/ad-box.png" class="ad-img">
        </div>
        <div class="ad-bottom">
            <div>首款光交互加持的存包柜现已上市</div>
            <div>欢迎试用丨垂询热线：0571-86811305</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Adv"
    }
</script>

<style scoped lang="less">
.ad-box{
    min-height: 100vh;
    background: #4F6BE8;
}
.ad-title{
    width: 75%;
    margin: 0 auto;
    text-align: right;
    padding: 3vh 0;
    color: #C9D3FF;
    font-size: 2.2vh;
    .text{
        line-height: 5.5vh;
    }
}
.ad-text{
    width: 25vh;
}
.ad-img{
    width: 100%;
}
.ad-bottom{
    padding: 5vh 4vh;
    color: #ffffff;
    :nth-child(1){
        font-size: 2.5vh;
        font-weight: bolder;
        line-height: 3.5vh;
    }
    :nth-child(2){
        font-size: 2vh;
        line-height: 6vh;
    }
}
</style>
